import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {VideoPlatformConfig} from '../video-platforms';
import {VideoInfo, VideoPlatformId, VideoRow} from '../video-types';

interface RutubeOEmbedResponse {
  thumbnail_url?: string;
  title?: string;
  author_name?: string;
  author_url?: string;
  html?: string;
}

export class RutubePlatform extends VideoPlatformConfig {
  readonly name = 'Rutube';
  readonly id = VideoPlatformId.RUTUBE;
  readonly patterns = [/^https?:\/\/(?:www\.)?rutube\.ru\/video\/([a-fA-F0-9]+)/];
  readonly exampleLink = 'https://rutube.ru/video/ef5dc51c48ec3137fc9b76fe40bb07af/';

  getInfo(row: VideoRow, http: HttpClient): Observable<VideoInfo> {
    const code = this.getVideoCode(row);
    if (!code) {
      return this.createEmptyInfo(row);
    }

    const url = row.link || `https://rutube.ru/video/${code}/`;

    return http.get<RutubeOEmbedResponse>(
      `https://rutube.ru/api/oembed/?url=${encodeURIComponent(url)}&format=json`,
      {headers: this.httpHeaders}
    ).pipe(
      map(response => this.mapResponse(response, url, code)),
      catchError(() => this.createEmptyInfo(row))
    );
  }

  getPreview(row: VideoRow): string {
    const code = this.getVideoCode(row);
    return code ? `https://rutube.ru/api/video/${code}/thumbnail/?redirect=1` : '';
  }

  getEmbedUrl(row: VideoRow): string {
    const code = this.getVideoCode(row);
    return code ? `https://rutube.ru/play/embed/${code}/` : '';
  }

  private mapResponse(response: RutubeOEmbedResponse, url: string, code: string): VideoInfo {
    return {
      link: url,
      preview: response.thumbnail_url || `https://rutube.ru/api/video/${code}/thumbnail/?redirect=1`,
      title: response.title || ''
    };
  }
}
